import type { CreateCustomerProfileDto } from '../../../api/models/CreateCustomerProfileDto';

export type ClientDrawerFormState = {
  customerName: string;
  identityDocumentNumber: string;
  customerEmail: string;
  customerPhone: string;
  referenceNumber1: string;
  referenceNumber2: string;
  customerAddress: string;
  dateOfBirth: string;
  gender: '' | CreateCustomerProfileDto.gender;
  preferredPaymentMethod: '' | CreateCustomerProfileDto.preferredPaymentMethod;
  customerNotes: string;
  loyaltyTier: CreateCustomerProfileDto.loyaltyTier;
  marketingConsent: boolean;
  referralSource: string;
};

export type ClientDrawerFormSeed = Omit<Partial<ClientDrawerFormState>, 'dateOfBirth'> & {
  id?: number;
  dateOfBirth?: string | Date;
};

export type ClientCreateDrawerProps = {
  open: boolean;
  onClose: () => void;
  mode?: 'create' | 'edit' | 'view';
  initialData?: ClientDrawerFormSeed;
  onCreated?: (data: ClientDrawerFormSeed) => void;
  onUpdated?: (data: ClientDrawerFormSeed) => void;
};

export type ClientDrawerStep = 'FORM' | 'CONFIRMATION';

export const CLIENT_DRAWER_TOTAL_STEPS = 2;
export const CLIENT_DRAWER_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const CLIENT_DRAWER_HISTORY_PAGE_SIZE = 8;
